import React from "react"

function IconLayoutUserBottomPanel({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="layout-user-bottom-panel"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-layout-user-bottom-panel"
      {...props}
    >
      <path
        d="M19.636 3.273c.603 0 1.091.488 1.091 1.09v15.273a1.09 1.09 0 0 1-1.09 1.091H4.363a1.09 1.09 0 0 1-1.091-1.09V4.363c0-.603.488-1.091 1.09-1.091h15.273zm-.218 14.4H4.582v1.745h14.836v-1.745zm0-13.091H4.582v11.563h3.273v-1.657c0-.955.62-1.797 1.528-2.082a3.235 3.235 0 0 1-.713-1.842l-.006-.195V8.771c0-1.83 1.518-3.306 3.381-3.306 1.797 0 3.273 1.373 3.376 3.112l.005.194v1.598c0 .764-.265 1.47-.714 2.03l-.037-.013a2.182 2.182 0 0 1 1.58 2.097v1.662h3.163V4.582zm-6.002 8.806c-.303.132-.63.222-.974.263l-.197.018-.2.006c-.482 0-.942-.1-1.357-.278l-.89.252a.873.873 0 0 0-.627.724l-.007.115v1.657h5.78l.001-1.662a.873.873 0 0 0-.511-.794l-.12-.044-.898-.257zm-.679-1.136.16-.063.104-.05.084-.043c.063-.035.123-.073.181-.114l.118-.089c.409-.334.68-.818.726-1.36l.007-.164V8.771c0-1.098-.923-1.996-2.072-1.996-1.094 0-1.983.814-2.066 1.84l-.006.156v1.598c0 .67.344 1.265.868 1.628.088.062.185.118.286.166l.172.072.136.046.188.045.146.023.083.01.173.007.158-.005.19-.02.189-.039.175-.05z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconLayoutUserBottomPanel
